module.exports = __webpack_public_path__ + "static/media/quickto-cart--active.161f9bd4.svg";